import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule, Routes } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PipesModule } from '@app/core/pipes';
import { LiveScoresComponent } from './live-scores/live-scores.component';
import { SportsComponent } from './sports/sports.component';
import { SharedModule } from '@app/core/shared/shared.module';
import { ValidSportResolver } from '@app/core/resolvers/valid-sport.resolver';
import { ReactiveFormsModule } from '@angular/forms';
import { SubscriptionModule } from '../pages/subscription/subscription.module';
import { PassiveListenerDirective } from '@app/core/directives/passive-listner.directive';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@views/pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: ':sport',
    component: LayoutComponent,
    children: [
      {
        path: '',
        resolve: { sport: ValidSportResolver },
        loadChildren: () =>
          import('@views/pages/pages.module').then((m) => m.PagesModule),
      }
    ],
  },
];

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    LiveScoresComponent,
    SportsComponent,
    PassiveListenerDirective
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CarouselModule,
    PipesModule,
    SharedModule,
    ReactiveFormsModule,
    SubscriptionModule
  ],
  exports: [FooterComponent],
})
export class LayoutModule {}
